import { BoardStatKeys, BoardStats, ConfettiMode, GamePhase } from '../../app/types';
import { GameEngine } from '../game-engine-helper';
import { SFSObject } from 'sfs2x-api';
import { SFSVAR } from '../sfsVar';
import {
    claimButton,
    concedeButton,
    continueButton, leaderBoardButton,
    nextHandButton,
    pickBattleButton,
    undoButton,
} from '../buttonsState';
import { getEndOfWarMessage } from '../../utils/shark-helper';
import { modalGameResults } from '../../utils/modal.helper';
import { parseRawWarData } from '../../slices/warSlice';

export function MID_TIME_TO_SCORE(cmdObj: SFSObject, sender: GameEngine) {
    return;
}

export async function MID_TIME_TO_SCORE_SB(cmdObj: SFSObject, sender: GameEngine) {
    sender.hideButtons([claimButton, concedeButton, undoButton]);
    sender.props.table_setAuxiliaryMessage({ position: 'center', message: undefined });
    sender.props.table_setAuxiliaryMessage({ position: 'right', message: undefined });
    sender.props.table_setAuxiliaryMessage({ position: 'left', message: undefined });
    sender.props.table_setGamePhase(GamePhase.END);

    const oblState: SFSObject | undefined = cmdObj.containsKey('oplay') ? cmdObj.getSFSObject('oplay') : undefined;
    if (oblState) {
        sender.setHandsFromScore(oblState, true, 'h');
    }
    const nsTricks: number = cmdObj.containsKey('nstr')
        ? cmdObj.getInt('nstr')
        : oblState?.containsKey('nstr')
        ? oblState.getInt('nstr')
        : 0;
    const ewTricks: number = cmdObj.containsKey('ewtr')
        ? cmdObj.getInt('ewtr')
        : oblState?.containsKey('ewtr')
        ? oblState.getInt('ewtr')
        : 0;

    sender.props.table_setTrickCounts({ ns: nsTricks, ew: ewTricks });
    const score: number = cmdObj.getInt(SFSVAR.SFSGAME_MID_LOAD);

    if (!sender.props.app.engineStateInterface.isMiniBridge) {
        sender.props.table_setShowAuctionLine(true);
    }

    try {
        if (cmdObj.containsKey('stats')) {
            const json = new TextDecoder('utf-8').decode(cmdObj.getByteArray('stats'));
            const boardStats: BoardStats[] = JSON.parse(json) as BoardStats[];
            sender.props.table_setBoardStats(boardStats);
            if (cmdObj.containsKey('mystat')) {
                const myStatsKey: BoardStatKeys = JSON.parse(
                    new TextDecoder('utf-8').decode(cmdObj.getByteArray('mystat')),
                ) as BoardStatKeys;
                sender.props.table_setMyBoardStatKeys(myStatsKey);
            } else {
                sender.props.table_setMyBoardStatKeys({} as BoardStatKeys);
            }
        } else {
            sender.props.table_setBoardStats([]);
            sender.props.table_setMyBoardStatKeys({} as BoardStatKeys);
        }
    } catch (e) {
        //
    }
    const delay = () => new Promise((resolve) => setTimeout(resolve, 0));
    await delay();

    sender.updateBoardData(undefined);
    sender.props.table_setWalkTrough({ content: `Your Score: ${score}` });

    if (sender.props.app.engineStateInterface.hasNext) {
        sender.showButtons([nextHandButton]);
    }
    else {
        sender.showButtons([leaderBoardButton]);
    }
}

export async function MID_TIME_TO_SCORE_BWAR(cmdObj: SFSObject, sender: GameEngine) {
    const delay = () => new Promise((resolve) => setTimeout(resolve, 0));
    await delay();
    sender.hideButtons([claimButton, concedeButton, undoButton]);
    sender.props.table_setAuxiliaryMessage({ position: 'center', message: undefined });
    sender.props.table_setAuxiliaryMessage({ position: 'right', message: undefined });
    sender.props.table_setAuxiliaryMessage({ position: 'left', message: undefined });
    sender.props.table_setGamePhase(GamePhase.END);
    sender.props.table_setShowAuctionLine(false);
    const oblState: SFSObject | undefined = cmdObj.containsKey('oplay') ? cmdObj.getSFSObject('oplay') : undefined;
    if (oblState) {
        sender.setHandsFromScore(oblState, true, 'h');
    }
    const nsTricks: number = cmdObj.containsKey('nstr')
        ? cmdObj.getInt('nstr')
        : oblState?.containsKey('nstr')
        ? oblState.getInt('nstr')
        : 0;
    const ewTricks: number = cmdObj.containsKey('ewtr')
        ? cmdObj.getInt('ewtr')
        : oblState?.containsKey('ewtr')
        ? oblState.getInt('ewtr')
        : 0;

    sender.props.table_setTrickCounts({ ns: nsTricks, ew: ewTricks });
    //sender.props.table_setWalkTrough({ content: `You took ${nsTricks} ${nsTricks === 1 ? 'trick' : 'tricks'}` });

    try {
        if (cmdObj.containsKey('stats')) {
            const json = new TextDecoder('utf-8').decode(cmdObj.getByteArray('stats'));
            const boardStats: BoardStats[] = JSON.parse(json) as BoardStats[];
            sender.props.table_setBoardStats(boardStats);
            if (cmdObj.containsKey('mystat')) {
                const myStatsKey: BoardStatKeys = JSON.parse(
                    new TextDecoder('utf-8').decode(cmdObj.getByteArray('mystat')),
                ) as BoardStatKeys;
                sender.props.table_setMyBoardStatKeys(myStatsKey);
            } else {
                sender.props.table_setMyBoardStatKeys({} as BoardStatKeys);
            }
        } else {
            sender.props.table_setBoardStats([]);
            sender.props.table_setMyBoardStatKeys({} as BoardStatKeys);
        }
    } catch (e) {
        //
    }

    if (sender.props.app.engineStateInterface.hasNext) {
        sender.showButtons([nextHandButton]);
    } else {
        sender.showButtons([continueButton]);
    }

    sender.updateBoardData(undefined);

    const battles = cmdObj.getSFSObject('myresults').getSFSArray('battles');

    //sender.props.setWarData(parseRawWarData(battles));

    const duels = battles.getSFSObject(battles.size() - 1).getSFSArray('duels');
    const lastDuel = duels.getSFSObject(duels.size() - 1);
    let boardsWon = 0;
    for (let i = 0; i < duels.size(); i++) {
        const duel = duels.getSFSObject(i);
        if (duel.getInt('s') > 0) {
            boardsWon++;
        }
    }

    let confetiMode: ConfettiMode | undefined = undefined;
    const boardsPlayed = duels.size();
    let resultWin = 0;
    let resultDraw = 0;
    let resultLoss = 0;
    let battleDisplay: string;
    for (let i = 0; i < battles.size(); i++) {
        const battle = battles.getSFSObject(i);
        const battleStatus = battle.getUtfString('status');
        if (battleStatus === 'win') {
            resultWin++;
        } else if (battleStatus === 'loss') {
            resultLoss++;
        } else if (battleStatus === 'draw') {
            resultDraw++;
        }
    }

    let battleHeader = 'Victory!';
    if (resultWin > resultLoss) {
        confetiMode = ConfettiMode.warSmallWin;
        battleHeader = 'Victory!';
        battleDisplay = 'Your name will echo in legend';
    } else if (resultWin === resultLoss) {
        confetiMode = ConfettiMode.warDraw;
        battleHeader = 'Stand-off';
        battleDisplay = 'The battle ends but the war goes on';
    } else {
        confetiMode = ConfettiMode.warLoss;
        battleHeader = 'Vanquished';
        battleDisplay = 'But a warrior never yields';
    }

    if (resultWin === 4) {
        confetiMode = ConfettiMode.warBigWin;
    }

    const duelRecord = `</br>Duel Record </br> ${boardsWon} - ${boardsPlayed - boardsWon}`;
    const trickMessage = `You took ${nsTricks} ${nsTricks === 1 ? 'trick' : 'tricks'}`;
    const battleRecord = `</br>Battle Record </br> ${resultWin} - ${resultLoss} - ${resultDraw}`;
    const endOfBattleMessage = `${battleDisplay} </br>${trickMessage}</br>${duelRecord}</br>${battleRecord}`;
    if (resultWin + resultLoss + resultDraw === 4) {
        //We are at the end of the War adjust the message and show modal.
        sender.props.table_updateFooterButtons([{ key: 'button-4', button: pickBattleButton }]);
        sender.props.app_addModal(
            getEndOfWarMessage(confetiMode, endOfBattleMessage, battleHeader, {
                cancelLabel: 'Home Base',
                okLabel: 'War Review',
                cancel: () => {
                    parent.postMessage('reloaddash', '*');
                    parent.location.href = sender.returnURL;
                },
                confirm: () => {
                    const _modalGameResults = modalGameResults({
                        gameResults: sender.props.table.sharkGameResultsV2,
                        noCancel: false,
                        noClickOutside: true,
                        fullSize: true,
                    });
                    sender.props.app_addModal(_modalGameResults);
                },
            }),
        );
        return;
    } else if (boardsPlayed === 4) {
        confetiMode =
            boardsWon === 4
                ? ConfettiMode.battleBigWin
                : boardsWon === 3
                ? ConfettiMode.battleSmallWin
                : boardsWon === 2
                ? ConfettiMode.battleDraw
                : ConfettiMode.battleLoss;

        //We are at the end of the battle adjust the message and show modal.
        sender.props.app_addModal(
            getEndOfWarMessage(confetiMode, endOfBattleMessage, battleHeader, {
                cancelLabel: 'Home Base',
                okLabel: 'Next Battle',
                cancel: () => {
                    parent.postMessage('reloaddash', '*');
                    parent.location.href = sender.returnURL;
                },
                confirm: () => {
                    sender.clientRequestsNextHand();
                },
            }),
        );
        return;
    }

    let duelHeader = '';
    let m = '';
    if (lastDuel.getInt('s') > 0) {
        confetiMode = ConfettiMode.duelWin;
        duelHeader = 'Glory is Yours';
        m = 'To the victor goes the spoils!';
    } else {
        confetiMode = ConfettiMode.duelLoss;
        duelHeader = 'Bested';
        m = 'But your courage is unshaken';
    }
    const displayMessage = `${m} </br>${trickMessage}</br>${duelRecord}</br>${battleRecord}`;
    sender.props.app_addModal(
        getEndOfWarMessage(confetiMode, displayMessage, duelHeader, {
            cancelLabel: 'Home Base',
            okLabel: 'Next Duel',
            cancel: () => {
                parent.postMessage('reloaddash', '*');
                parent.location.href = sender.returnURL;
            },
            confirm: () => {
                sender.clientRequestsNextHand();
            },
        }),
    );
    return;
}
